import axios from "@/plugins/axios";

export function getMomentListByPageNum(token, pageNum, pageSize) {
  return axios({
    url: "Site/GetDyNamic",
    method: "GET",
    headers: {
      Authorization: token,
    },
    params: {
      pageIndex: pageNum,
      pageSize,
    },
  });
}

export function likeMoment(id) {
  return axios({
    url: `Site/UpdateLikesAsync`,
    method: "put",
    params: {
      id,
    },
  });
}
